import { makeStyles } from '@material-ui/core';

export const getShadowRootContainerStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
}));
